/**
* @Author: zhangkaicheng
* @Date: 2025/10/15
* @LastEditors: zhangkaicheng
* @Tips: SECURE_STORAGE_KEYS 中 只对敏感 key（如 'loginInfo'）启用，不能滥用
* @Description 浏览器端存储敏感信息，常量列表，SECURE_STORAGE_KEYS 可增加，需要加密的key
**/

// sm4加密密钥
export const SM4_KEY = '7A9C98341EDB4E07A8AAFB7935D6CBCE';

// 存储需要加密的敏感key
export const SECURE_STORAGE_KEYS = [
  'loginInfo', // 用户登录信息
  'PUGC.TOKEN_DATA', // 投稿平台token
  'PUGC.APP_PRI_KEY', // 投稿平台app假私钥
  'PUGC.APP_PUB_KEY', // 投稿平台app假公钥
];
